// extracted by mini-css-extract-plugin
export default {"thumb":"WithImagesTemplate-module__[local]___xas3+"};